import { unwrapResult } from '@reduxjs/toolkit';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowForwardIcon } from '@rsos/assets/icons';
import {
  ALERTS_FIRE,
  ALERTS_LAW_ENFORCEMENT,
  ALERTS_MEDICAL,
  ALERTS_ACTIVE_ASSAILANT,
} from '@rsos/capstone/src/constants/capabilities';
import { Box, Text, Button } from '@rsos/components/capstone/base';
import { fetchAgencies } from '@rsos/reduxDataStore/src/features/alertsRouting/alertsRoutingSlice';
import OutboundAlertsTable from './OutboundAlertsTable';
import PairAgencyModal from './PairAgencyModal/PairAuthorityModal';

const OutboundAlerts = () => {
  const dispatch = useDispatch();

  const { sinatra, psaps } = useSelector(state => state);
  const org = sinatra.user.currentOrg.name;

  const hasAlertsPermission = !!(
    sinatra.user.currentRole.permissions &&
    sinatra.user.currentRole.permissions.includes('ALERTS')
  );
  const isAnyAlertsCapabilityEnabled = !!(
    psaps?.currentPSAP?.activeCapabilities &&
    (psaps.currentPSAP.activeCapabilities[ALERTS_FIRE] ||
      psaps.currentPSAP.activeCapabilities[ALERTS_LAW_ENFORCEMENT] ||
      psaps.currentPSAP.activeCapabilities[ALERTS_MEDICAL] ||
      psaps.currentPSAP.activeCapabilities[ALERTS_ACTIVE_ASSAILANT])
  );
  const hasAlertsAccess = hasAlertsPermission && isAnyAlertsCapabilityEnabled;

  const agencyLinks = useSelector(state => state.alertsRouting.agencyLinks);
  const { linksTo, shareableAlertEmergencyTypes } = agencyLinks;
  const [authorities, setAuthorities] = useState([]);
  const [isPairAgencyModalOpened, setIsPairAgencyModalOpened] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isFetchError, setIsFetchError] = useState(null);
  const data = { org };

  const fetchAvailableAgencies = () => {
    setIsFetching(true);
    setIsFetchError(null);
    dispatch(fetchAgencies(data))
      .then(unwrapResult)
      .then(response => {
        setAuthorities(response.authorities);
      })
      .catch(error => {
        setIsFetchError(error);
      })
      .finally(() => {
        setIsFetching(false);
      });
  };

  const retryFetchAvailableAgencies = () => {
    fetchAvailableAgencies();
  };

  const handleCloseModal = () => {
    setIsPairAgencyModalOpened(false);
  };

  const handlePair = () => {
    setIsPairAgencyModalOpened(true);
    fetchAvailableAgencies();
  };

  return (
    <>
      <Box horizontal justify="space-between" mb={10}>
        <Box opacity={!hasAlertsAccess ? 0.4 : 1}>
          <Text size="normal" fontWeight="bold" color="primaryText">
            Shared Outbound Alerts
          </Text>
          <Box mt="4px">
            <Text size="small" color="secondaryText">
              Invite agencies to receive your shared alerts. Below is the list
              of agencies that will receive your alerts.
            </Text>
          </Box>
        </Box>
        <Button
          btnType="primary"
          onClick={handlePair}
          size="small"
          disabled={!hasAlertsAccess}
          px={20}
        >
          Pair agency
          <Box ml="5px">
            <ArrowForwardIcon />
          </Box>
        </Button>
      </Box>
      <OutboundAlertsTable
        linksTo={linksTo}
        hasAlertsAccess={hasAlertsAccess}
      />
      <PairAgencyModal
        isOpened={isPairAgencyModalOpened}
        onClose={handleCloseModal}
        authorities={authorities}
        alertTypes={shareableAlertEmergencyTypes}
        isFetchError={isFetchError}
        isFetching={isFetching}
        retryFetchAvailableAgencies={retryFetchAvailableAgencies}
      />
    </>
  );
};

export default OutboundAlerts;
